// /utils/coreApiInstance.js

import createAxiosInstance from "./tokenManager";

const coreApiInstance = createAxiosInstance(process.env.REACT_APP_API_URL);

export default coreApiInstance;
